export default __webpack_public_path__ + "static/media/Icon simple-linkedin.a5e8eb37.svg";